import {httpRemoveProjectIncomplete} from '@/features/projects/http/projects.http'
import {MUTATION_KEYS} from '@/queryClient'
import {useMutation, UseMutationOptions} from '@tanstack/react-query'
import {AxiosResponse} from 'axios'

export const useRemoveProjectIncomplete = ({
    urlParams,
    options
}: {
    urlParams: {projectId: string}
    options?: Omit<UseMutationOptions<AxiosResponse, unknown, void>, 'mutationFn'>
}) =>
    useMutation({
        mutationKey: [MUTATION_KEYS.REMOVE_PROJECT_INCOMPLETE, urlParams.projectId],
        mutationFn: () => httpRemoveProjectIncomplete({urlParams}),
        ...options
    })
